export enum JetEventCode {
  // 10 - Changement du mode de gestion de la séquence continue
  CHANGE_SEQUENCE_MODE = 10,
  // 20 - Archivage fiscal de période
  INTERMEDIATE_FISCAL_ARCHIVE = 20,
  // 30 - Archivage fiscal d'année ou d'exercice
  FISCAL_YEAR_ARCHIVE = 30,
  // 40 - Arrêt du terminal, déconnexion, fermeture de session
  SESSION_STOP = 40,
  // 50 - Clôture de période (Jour/Mois)
  PERIOD_CLOSE = 50,
  // 60 - Clôture annuelle ou d'exercice
  YEAR_CLOSE = 60,
  // 70 - Début de mode dégradé (hors connexion)
  DEGRADED_MODE_START = 70,
  // 80 - Démarrage du terminal, connexion, ouverture de session
  SESSION_START = 80,
  // 90 - Détection d'un défaut d'intégrité
  INTEGRITY_FAILURE = 90,
  // 95 - Détection d'une rupture de la séquence continue
  SEQUENCE_BREAK = 95,
  // 100 - Début de l'exécution d'une fonction spéciale (mode formation, etc.)
  SPECIAL_FUNCTION_START = 100,
  // 105 - Fin de l'exécution d'une fonction spéciale
  SPECIAL_FUNCTION_END = 105,
  // 110 - Exportation de données
  DATA_EXPORT = 110,
  // 120 - Fin de mode dégradé
  DEGRADED_MODE_END = 120,
  // 130 - Habilitation d'utilisateur/Gestion des droits
  USER_RIGHTS_CHANGE = 130,
  // 150 - Imprimante indisponible
  PRINTER_UNAVAILABLE = 150,
  // 155 - Duplicata d'une note (N/A - Connect'Events n'émet pas de "notes")
  DUPLICATE_TICKET = 155,
  // 156 - Duplicata d'un justificatif de paiement (N/A - Connect'Events n'émet pas de "justificatif de paiement")
  DUPLICATE_PAYMENT_PROOF = 156,
  // 190 - Annulation de pièce justificative ticket
  CANCEL_TICKET = 190,
  // 200 - Purge des données
  DATA_PURGE = 200,
  // 205 - Purge partielle du JET
  JET_PURGE = 205,
  // 210 - Reprise de données d'autres logiciels
  DATA_RECOVERY = 210,
  // 220 - Restauration d'une base de données
  DATABASE_RESTORE = 220,
  // 230 - Sauvegarde d'une base de données
  DATABASE_BACKUP = 230,
  // 250 - Installation d'une nouvelle version majeure du logiciel
  SOFTWARE_UPDATE_MAJOR = 250,
  // 255 - Installation d'une nouvelle version mineure du logiciel
  SOFTWARE_UPDATE_MINOR = 255,
  // 260 - Initialisation des données
  DATA_INITIALIZATION = 260,
  // 270 - Évolution de paramètre de conformité aux règles
  COMPLIANCE_PARAMETER_CHANGE = 270,
  // 280 - Début/fin d'opération de contrôle fiscal
  FISCAL_CONTROL = 280,
  // 295 - Transfert de fichier à la demande de l'administration
  FILE_TRANSFER_ADMIN = 295,
  // 320 - Abandon d'une opération de vente non encore enregistrée
  TRANSACTION_ABANDON = 320,
  // 330 - Initialisation de la clôture de fin de période
  CLOSURE_INITIALIZATION = 330,
  // 420 - Changement de mode de paiement après encaissement
  PAYMENT_METHOD_CHANGE = 420,
  // 450 - Traçabilité du changement du trousseau de clés
  KEY_ROTATION = 450,
}

export const JetEventLabels: Record<JetEventCode, string> = {
  [JetEventCode.CHANGE_SEQUENCE_MODE]: "Changement du mode de gestion de la séquence continue",
  [JetEventCode.INTERMEDIATE_FISCAL_ARCHIVE]: "Archivage fiscal de période",
  [JetEventCode.FISCAL_YEAR_ARCHIVE]: "Archivage fiscal d'année ou d'exercice",
  [JetEventCode.SESSION_STOP]: "Arrêt du terminal, déconnexion, fermeture de session",
  [JetEventCode.PERIOD_CLOSE]: "Clôture de période (Jour/Mois)",
  [JetEventCode.YEAR_CLOSE]: "Clôture annuelle ou d'exercice",
  [JetEventCode.DEGRADED_MODE_START]: "Début de mode dégradé (hors connexion)",
  [JetEventCode.SESSION_START]: "Démarrage du terminal, connexion, ouverture de session",
  [JetEventCode.INTEGRITY_FAILURE]: "Détection d'un défaut d'intégrité dans les données sécurisées",
  [JetEventCode.SEQUENCE_BREAK]: "Détection d'une rupture de la séquence continue",
  [JetEventCode.SPECIAL_FUNCTION_START]: "Début de l'exécution d'une fonction spéciale",
  [JetEventCode.SPECIAL_FUNCTION_END]: "Fin de l'exécution d'une fonction spéciale",
  [JetEventCode.DATA_EXPORT]: "Exportation de données",
  [JetEventCode.DEGRADED_MODE_END]: "Fin de mode dégradé",
  [JetEventCode.USER_RIGHTS_CHANGE]: "Habilitation d'utilisateur/Gestion des droits",
  [JetEventCode.PRINTER_UNAVAILABLE]: "Imprimante indisponible",
  [JetEventCode.DUPLICATE_TICKET]: "Duplicata d'une note",
  [JetEventCode.DUPLICATE_PAYMENT_PROOF]: "Duplicata d'un justificatif de paiement",
  [JetEventCode.CANCEL_TICKET]: "Annulation de pièce justificative ticket",
  [JetEventCode.DATA_PURGE]: "Purge des données",
  [JetEventCode.JET_PURGE]: "Purge partielle du JET",
  [JetEventCode.DATA_RECOVERY]:
    "Reprise de données d'autres logiciels suite à changement de systèmes",
  [JetEventCode.DATABASE_RESTORE]: "Restauration d'une base de données",
  [JetEventCode.DATABASE_BACKUP]: "Sauvegarde d'une base de données",
  [JetEventCode.SOFTWARE_UPDATE_MAJOR]: "Installation d'une nouvelle version majeure du logiciel",
  [JetEventCode.SOFTWARE_UPDATE_MINOR]: "Installation d'une nouvelle version mineure du logiciel",
  [JetEventCode.DATA_INITIALIZATION]: "Initialisation des données",
  [JetEventCode.COMPLIANCE_PARAMETER_CHANGE]: "Évolution de paramètre de conformité aux règles",
  [JetEventCode.FISCAL_CONTROL]: "Début/fin d'opération de contrôle fiscal",
  [JetEventCode.FILE_TRANSFER_ADMIN]: "Transfert de fichier à la demande de l'administration",
  [JetEventCode.TRANSACTION_ABANDON]: "Abandon d'une opération de vente non encore enregistrée",
  [JetEventCode.CLOSURE_INITIALIZATION]: "Initialisation de la clôture de fin de période",
  [JetEventCode.PAYMENT_METHOD_CHANGE]: "Changement de mode de paiement après encaissement",
  [JetEventCode.KEY_ROTATION]: "Traçabilité du changement du trousseau de clés utilisé pour signer",
};

export const isJetCode = (code: unknown): code is JetEventCode => {
  if (typeof code !== "number") return false;

  return Object.values(JetEventCode).includes(code);
};

export const asJetCode = (code: unknown): JetEventCode => {
  if (!isJetCode(code)) {
    throw new Error(`Invalid jet code: ${code}`);
  }
  return code;
};
